import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PaginationComponent } from './pagination/pagination.component';
import { SearchPaginationComponent } from './search-pagination/search-pagination.component';
import { ElegantLoaderComponent } from './elegant-loader/elegant-loader.component';
import { ToastComponent } from './toast/toast.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { GenericMessage } from './generic-message/generic-message.component';
import { AuthHeaderComponent } from './auth-header/auth-header.component';

import { OnlyNumberDirective } from './directives/appOnlyDirective.directive';
import {
  DecimalPositiveDirective,
  InputRestrictionDirective,
  OnlyDecimalNumberDirective,
  PinCodeDirective,
} from './directives/inputRestriction.directive';

const COMPONENTS = [
  PaginationComponent,
  SearchPaginationComponent,
  ElegantLoaderComponent,
  ToastComponent,
  ConfirmDialogComponent,
  GenericMessage,
  AuthHeaderComponent,
];

const DIRECTIVES = [
  OnlyNumberDirective,
  DecimalPositiveDirective,
  InputRestrictionDirective,
  OnlyDecimalNumberDirective,
  PinCodeDirective,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
    ...DIRECTIVES,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [
    ...COMPONENTS,
    ...DIRECTIVES,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class SharedModule { }
